import polarToCartesian from "@/domains/targetMenu/helpers/polarToCartesian";

const describeArc = (x, y, r, startAngle, endAngle, continueLine) => {
  const normalizedStartAngle = startAngle % 360;
  const normalizedEndAngle = endAngle % 360;
  const start = polarToCartesian(x, y, r, normalizedStartAngle);
  const end = polarToCartesian(x, y, r, normalizedEndAngle);
  const large = Math.abs(endAngle - startAngle) >= 180;
  const alter = endAngle > startAngle;

  return `${continueLine ? "L" : "M"}${start.x} ${start.y} A${r} ${r}, 0, ${large ? 1 : 0}, ${alter ? 1 : 0}, ${end.x} ${end.y}`;
};

export default describeArc;
